export default __webpack_public_path__ + "static/media/NEAS0460.34I-35095_-20110_0.662aec54.jpg";